import { Stack, Box, FormControlLabel, Checkbox, Typography, Link } from "@mui/material";
import { useForm, FormProvider, useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TranslationKey } from "../../i18n/i18n";
import { UserTermsOfUse } from "./termsApproval";
import { SenecButton } from "@newsenec/ui-components";

interface FormData {
    termsOfUse: boolean;
}

interface TermsCheckBoxProps {
    formId: keyof FormData;
    terms: TranslationKey;
    link: string;
}

export const TermsApprovalForm = ({ termsOfUse, onSubmit }: { termsOfUse: UserTermsOfUse; onSubmit: () => void }) => {
    const { t } = useTranslation();

    const formProvider = useForm<FormData>({
        defaultValues: { termsOfUse: false },
    });

    const allTermsApproved = () => {
        const values = Object.values(formProvider.watch());
        return values.filter((value) => value === true).length === values.length;
    };

    return (
        <FormProvider {...formProvider}>
            <form onSubmit={formProvider.handleSubmit(onSubmit)}>
                <Stack spacing={2} justifyContent="center" alignItems="center">
                    <TermsCheckBox formId="termsOfUse" terms="termsApprovalScreen.termsOfUse" link={termsOfUse.url} />
                    <Box>
                        <SenecButton
                            data-testid="login-terms-approval-accept"
                            disabled={!allTermsApproved()}
                            type="submit"
                            level="primary"
                        >
                            {t("termsApprovalScreen.acceptButton")}
                        </SenecButton>
                    </Box>
                </Stack>
            </form>
        </FormProvider>
    );
};

export const TermsCheckBox = ({ formId, terms, link }: TermsCheckBoxProps) => {
    const { t } = useTranslation();
    const { field } = useController<FormData>({ name: formId });

    return (
        <FormControlLabel
            control={<Checkbox {...field} />}
            label={
                <Typography textAlign={{ xs: "left", lg: "center" }}>
                    {t("termsApprovalScreen.acceptTerms1")}
                    {
                        <Link href={link} target="_blank">
                            {t(terms)}
                        </Link>
                    }
                    {t("termsApprovalScreen.acceptTerms2")}
                </Typography>
            }
        />
    );
};
